import D2C_Instance from '../Instance'

class D2C_InstanceUpcloud extends D2C_Instance {
  static active = true
  static objectType = 'instanceType'
  static providerType = 'Upcloud'
}

export default D2C_InstanceUpcloud
